import { memo } from 'react'
import { type FC } from 'react'
import { useTranslator } from '@/hooks'
import { designGrid, getMargin5, getP15, getP40, mq, vw } from '@/styles'
import { motion } from 'motion/react'
import styled from 'styled-components'

const headingId = 'philosophy'
export const SectionPhilosophy:FC = memo(() => {
  const { t } = useTranslator()
  return (
    <Section aria-labelledby={headingId}>
      <h2 id={headingId}>{t('home.section_philosophy.title')}</h2>
      <div className='p-block' key={'md'} dangerouslySetInnerHTML={{
        __html: t('home.section_philosophy.description') as string
      }} />
    </Section>
  )
})

const Section = styled(motion.section)`
  ${designGrid({})}
  padding: ${vw(150, 'mobile')} 0 ${vw(100, 'mobile')};

  ${mq.greaterThan('tablet')} {
    padding: ${vw(200, 'desktop')} 0 ${vw(150, 'desktop')};
  }

  hgroup {
    grid-column: 1 / span 6;
  }

  h2 {
    grid-column: 1 / span 6;
  }

  > div {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 0;
    grid-column: 1 / span 6;
    justify-content: flex-start;

    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 11;
    }
  }

  h2,
  p {
    text-align: left;
  }

  h2 {
    ${getP15()}
    ${getMargin5()}
  }

  p {
    ${getP40()}
  }
`
